import React, { useState, useEffect } from 'react';
import { filesAPI } from '../api';
import SEO from '../components/SEO';

function PublicFiles() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadPublicFiles();
  }, []);

  const loadPublicFiles = async () => {
    setLoading(true);
    try {
      const response = await filesAPI.getPublicFiles(search);
      setFiles(response.data.files);
    } catch (error) {
      console.error('Error loading public files:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    loadPublicFiles();
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div className="container">
      <SEO
        title="Public Files - SharePanda"
        description="Browse and download publicly shared files on SharePanda. Access files shared by the community."
        url="https://sharepanda.org/public-files"
      />
      <h1 className="mb-3">Public Files</h1>
      <p className="text-muted mb-3">
        Browse and download publicly shared files
      </p>

      {/* Search */}
      <div className="card mb-3">
        <form onSubmit={handleSearch}>
          <div className="d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Search files..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button type="submit" className="btn btn-primary">
              Search
            </button>
          </div>
        </form>
      </div>

      {/* Files List */}
      <div className="card">
        <h3 className="mb-2">Available Files ({files.length})</h3>
        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : files.length === 0 ? (
          <p className="text-muted">No public files available.</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Filename</th>
                <th>Owner</th>
                <th>Size</th>
                <th>Downloads</th>
                <th>Uploaded</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {files.map((file) => (
                <tr key={`${file.owner}-${file.file_id}`}>
                  <td>{file.filename}</td>
                  <td>{file.owner}</td>
                  <td>{formatBytes(file.size)}</td>
                  <td>{formatNumber(file.downloads || 0)}</td>
                  <td>{formatDate(file.uploaded_at)}</td>
                  <td>
                    <a
                      href={filesAPI.downloadPublicFile(file.owner, file.file_id)}
                      className="btn btn-primary"
                      style={{ padding: '6px 12px', fontSize: '12px' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Download
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default PublicFiles;
